/**
 * ConfigCat remote configuration for the main PowerPoint agent model.
 *
 * The value can be any PowerPoint model-picker catalog id or wire id, GPT or
 * Claude; the agent resolves the provider from it. It replaces the older
 * OpenAI-only `pptxOpenAIModel` setting.
 *
 * This is not a feature gate: it selects runtime behavior without requiring an
 * add-in rebuild. The ConfigCat client hydrates this synchronous cache during
 * account initialization and refreshes it when remote configuration changes.
 */

export const POWERPOINT_MODEL_CONFIG_KEY = "pptxPluginModel";
export const DEFAULT_POWERPOINT_MODEL = "gpt-5.6-sol";

let activePowerPointModel = DEFAULT_POWERPOINT_MODEL;

export function getPowerPointModel(): string {
  return activePowerPointModel;
}

export function setPowerPointModel(value: string): void {
  activePowerPointModel = value.trim() || DEFAULT_POWERPOINT_MODEL;
}

export function resetPowerPointModel(): void {
  activePowerPointModel = DEFAULT_POWERPOINT_MODEL;
}
